import { useEffect, useState } from "react";
import * as webHelpers from "../../../../helpers/WebHelpers";
import { IJobsheet } from "../../../../interfaces/jobsheets/IJobsheet";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { IOriginalQuote, IQuote } from "../../../../interfaces/verbalquotes/IQuote";
import IQuoteLine from "../../../../interfaces/verbalquotes/IQuoteLine";
import { LinePricingType } from "../../../../interfaces/jobsheets/IWipline";

export const AlternativeWorks = ({jobsheet}: {jobsheet: IJobsheet}) => {
    const [quotes, setQuotes] = useState<IQuote[]>([]);

    const getQuote = async (jobNumber: string): Promise<IOriginalQuote | null> => {
        return webHelpers.getAsync<IOriginalQuote>("/api/sales/work/jobsheet/originalquote?job=" + jobNumber);
    }

    useEffect(() => {
        setQuotes([]);

        getQuote(jobsheet.id).then((res: IOriginalQuote | null) => {
            console.log(res);
            res?.quotes.forEach(x => {
                if (x.is_primary === false) {
                    setQuotes(prev => [...prev, x]);
                }
            });
        });
    }, [jobsheet]);

    if (quotes.length == 0) return <></>

    return (        
        <Box borderWidth='1px' borderColor='gray.400' borderRadius='lg' h='full'>
            <Heading m={2} size='md' color='var(--Able-blue)' p={2} borderBottom='2px' borderColor='gray.200'>Alternative Quoted Work</Heading>

                {quotes.map((quote: IQuote, index: number) => 
                    <Box w='full' p={2} px={{ base: 2, md: 4 }} key={"Alt"+index} mt={index > 0 ? 2 : 0}>
                        <Heading size='18px'>{quote.name}:</Heading>

                        {quote.lines.map((line: IQuoteLine, index: number) => 
                            <Flex direction='column' key={"AltLine"+index}>
                                <Text>{line.quantity}&#215; {line.name}</Text>
                                {line.props.pricing_type != LinePricingType.Subordinate &&
                                    <Text mb={1}><Text as='span' fontWeight='semibold'>Pricing: </Text>{line.props.calculate_price_description}</Text>
                                }
                            </Flex>
                        )}
                    </Box>
                )}
        </Box>
    )
}